import React from "react";
import PropTypes from "prop-types";

import { CreateContainer } from "./ContainerCreate";
import { getGenreUserFavorites } from "~/api/getChimneyProfile";
import Spinner from "react-bootstrap/Spinner";

class GenreFavoritesContainer extends React.Component {
  componentDidMount() {
    const { dir } = this.props;
    this.props.request(dir);
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const genres = (data && data.data && data.data.genres) || [];
    if (loading) {
      return <Spinner animation="border" variant="secondary" />;
    }
    return render({ genres, loading, failure });
  };
}

GenreFavoritesContainer.propTypes = {
  dir: PropTypes.string.isRequired,
};

export default CreateContainer(getGenreUserFavorites, GenreFavoritesContainer);
